import { FC } from 'react'

import { Link, ToOptions } from '@tanstack/react-router'

import { Navigation, NavigationItem, NavigationList } from '@forto-dev/phoenix-ui-core/ship'

import { useLocalisation } from '@/utils/localisation'

export type BackProps = {
  to: ToOptions['to']
  params?: ToOptions['params']
  search?: ToOptions['search']
}

export const Back: FC<BackProps> = ({ to, params, search }) => {
  const { translate } = useLocalisation()

  return (
    <Navigation>
      <NavigationList>
        <Link to={to} params={params} search={search}>
          <NavigationItem icon="ArrowLeft">{translate('navigation.back')}</NavigationItem>
        </Link>
      </NavigationList>
    </Navigation>
  )
}
